(function ($) {
  'use strict';

  var addToCal = function () {
    var self = $(this);
    var $atcBtn = $('.atc-btn', self);

    $atcBtn.click(function () {

      if (!$('.add-to-calendar-links', self).hasClass('visible')) {
        $('.add-to-calendar-links', self).addClass('visible');
      }
      else {
        $('.add-to-calendar-links', self).removeClass('visible');
      }
    });
  };

  /**
  * This is boilerplate: add a behavior to window.DP.behaviors
  */
  window.DP.behaviors.addToCal = {
    attach: function (context) {
      once('addToCal', '.atc-container', context)
        .forEach((e) => {
          addToCal.apply(e);
        });
      // $(context).find('.atc-container').once('addToCal').each(function () {
      //   addToCal.apply(this);
      // });
    }
  };

})(jQuery);
